import React from 'react'
import './Header.scss';
import {motion} from 'framer-motion';
import {images} from '../../constants';
import {AppWrap} from '../../wrapper'


const scaleVariants={
  whileInView:{
    scale:[0,1],
    opacity:[0,1],
    transition:{
      duration:1,
      ease:'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className='app_header app_flex'>
      <motion.div
        whileInView={{x:[-100,0],opacity:[0,1]}}
        transition={{duration:1}}
        className='app_header-info'
      >
        <div className='app_header-badge'>
          <div className='badge-cmp app_flex'>
              <span>👋</span>
              <div style={{marginLeft:20}}>
                <p className='p-text'>Hello, I am</p>
                <h1 className='head-text'>Kaushal</h1>
              </div>
          </div>
          <div className='tag-cmp app_flex'>
            <p className='p-text'>Python Developer | Full-Stack Web Developer | Automation & QA Engineer | Data Analyst | AI & Cloud Enthusiast </p><br/>
            <p className='p-text'>Dynamic tech enthusiast with hands-on experience in Python development, automation, QA, data analysis, and full-stack web applications. Proficient in building AI-powered solutions, automating workflows, and deploying scalable systems in cloud environments. Highly adaptable, quick to master new technologies, and passionate about delivering production-ready solutions that solve real problems.</p>
            <a
              href="/Kaushal_CV.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="cv-btn"
              style={{ marginTop: '1.5rem', alignSelf: 'center', textDecoration: 'none' }}
            >
              View CV
            </a>
          </div>
        </div>
      </motion.div>

      <motion.div
      whileInView={{opacity:[0,1]}}
      transition={{duration:0.5,delayChildren:0.5}}
      className='app_header-img'
      >
        <img src={images.Kaushal} alt="Kaushal Pic" className="profile-img"/>
        <motion.img
          whileInView={{scale:[0,1]}}
          transition={{duration:1,ease:'easeInOut'}}
          src={images.circle}
          alt="Portfolio_circle"
          className="overlay_circle"
        />
      </motion.div>
      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app_header-circles'
      
      >
        {[images.selenium,images.python, images.django, images.n8n, images.docker, images.azure, images.drf].map((circle,index)=>(
          <div className="circle-cmp app_flex" key={`circle-${index}`}>
            <img src={circle} alt="circle"/>
            </div>
        ))}
        
      </motion.div>
    </div>
  )
}


export default AppWrap(Header,'Home');
